import { createReducer } from "typesafe-actions";

import DateRange from "@mapmycustomers/shared/types/range/DateRange";

import DrillDownViewState from "@app/scene/dashboard/types/DrillDownViewState";
import ClosedStageDealAmountCardConfiguration from "@app/types/dashboard/cards/closedStageDealAmount/ClosedStageDealAmountCardConfiguration";
import { DEFAULT_PAGE_SIZE } from "@app/util/consts";
import { createEmptyFilterModel } from "@app/util/filters/utils";

import {
  applyClosedStageDealAmountDrillDownListViewSettings,
  ClosedStageDealAmountCardActions,
  fetchClosedStageDealAmountCardDrillDownData,
  hideClosedStageDealAmountDrillDown,
  showClosedStageDealAmountDrillDown,
} from "./actions";

export interface ClosedStageDealAmountCardState {
  configuration?: ClosedStageDealAmountCardConfiguration; // also works as a "visible" trigger, visible if set
  drillDownCustomDateRange?: DateRange;
  loading?: boolean;
  totalFilteredRecords: number;
  totalRecords: number;
  viewState: DrillDownViewState;
}

export const closedStageDealAmountInitialState: ClosedStageDealAmountCardState = {
  totalFilteredRecords: 0,
  totalRecords: 0,
  viewState: {
    columns: [],
    filter: createEmptyFilterModel(),
    range: { endRow: DEFAULT_PAGE_SIZE, startRow: 0 },
    sort: [],
  },
};

const closedStageDealAmountState = createReducer<
  ClosedStageDealAmountCardState,
  ClosedStageDealAmountCardActions
>(closedStageDealAmountInitialState)
  .handleAction(showClosedStageDealAmountDrillDown.request, (state, { payload }) => ({
    ...state,
    configuration: payload.configuration,
    drillDownCustomDateRange: payload.customDateRange,
  }))
  .handleAction(showClosedStageDealAmountDrillDown.success, (state, { payload }) => ({
    ...state,
    viewState: payload.viewState,
  }))
  .handleAction(hideClosedStageDealAmountDrillDown, (state) => ({
    ...state,
    configuration: undefined,
    drillDownCustomDateRange: undefined,
  }))
  .handleAction(fetchClosedStageDealAmountCardDrillDownData.request, (state) => ({
    ...state,
    loading: true,
  }))
  .handleAction(fetchClosedStageDealAmountCardDrillDownData.success, (state, { payload }) => ({
    ...state,
    loading: false,
    totalFilteredRecords: payload.totalFilteredRecords,
    totalRecords: payload.totalRecords,
  }))
  .handleAction(fetchClosedStageDealAmountCardDrillDownData.failure, (state) => ({
    ...state,
    loading: false,
  }))
  .handleAction(applyClosedStageDealAmountDrillDownListViewSettings, (state, { payload }) => ({
    ...state,
    viewState: {
      ...state.viewState,
      columns: payload.columns ?? state.viewState.columns,
      filter: payload.filter ?? state.viewState.filter,
      range: payload.range ?? state.viewState.range,
      sort: payload.sort ?? state.viewState.sort,
    },
  }));

export default closedStageDealAmountState;
